// pop-up-login-flow/messages.ts
var safeParse = (message) => {
  try {
    const parsed = JSON.parse(message);
    if ("type" in parsed && ["done", "init", "ping", "ready"].includes(parsed.type)) {
      return { parsed, error: null };
    }
    return { parsed: null, error: new Error("Unknown message format in auth post message handler") };
  } catch (error) {
    return { parsed: null, error };
  }
};
export {
  safeParse
};
